import styled from 'styled-components'

export const ButtonEdit = styled.button`
  border-radius: 3px;
  margin-top: 5px;
  margin-left: 35px;
  outline: none;
  border: none;
  cursor: pointer;
`

export const ButtonUpdate = styled.button`
  border-radius: 3px;
  margin-top: 5px;
  margin-left: 5px;
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: bold;
  background: white;
  color: #077;
`
